import React, { ReactNode, useState } from "react";
import { Box, Grid, IconButton } from "@mui/material";
import { UnfoldLess, UnfoldMore } from "@mui/icons-material";
import CircleIcon from "../../CircleIcon/CircleIcon";
import caseHistoryItemStyle from "./caseHistoryItemStyle";
import { GenericHistoryLog } from "../../../types/HistoryLog";
import dayjs from "dayjs";

interface GenericLogEntryProps {
  subject: string;
  Icon: any;
  iconType?: "muiIcon" | "iconFile";
  info?: ReactNode;
  historyItem: GenericHistoryLog;
  lineThrough?: boolean;
  userNameFallback?: string;
}

const GenericLogEntry = ({
  subject,
  Icon,
  iconType = "muiIcon",
  info = null,
  historyItem,
  lineThrough = false,
  userNameFallback = "System",
}: GenericLogEntryProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasDetails = info !== null;

  return (
    <Grid container>
      <Grid size={1}>
        <CircleIcon icon={iconType === "muiIcon" ? <Icon /> : Icon} type={iconType} />
      </Grid>
      <Grid size={11}>
        <Grid container wrap="nowrap">
          <Grid sx={{ flexGrow: 1 }}>
            <Box sx={lineThrough ? caseHistoryItemStyle.headlineLineThrough : caseHistoryItemStyle.headline}>
              {subject}
            </Box>
            <Box sx={caseHistoryItemStyle.info}>
              {dayjs(historyItem.logDate).format("DD.MM.YYYY HH:mm")} Uhr |{" "}
              {historyItem?.backofficeUser?.person.fullname || userNameFallback}
            </Box>
          </Grid>
          {hasDetails && (
            <Grid>
              <IconButton onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? <UnfoldLess /> : <UnfoldMore />}
              </IconButton>
            </Grid>
          )}
        </Grid>
        <Box sx={caseHistoryItemStyle.info}>{isExpanded && info}</Box>
      </Grid>
    </Grid>
  );
};

export default GenericLogEntry;
